import { TELECALLER_ID_UPDATION_SECTION } from "../../../Configuration/API_URL";
import api from "./api.service";

export const getClientDataByRefNumber = async (payload) => {
  const response = await api.post(
    TELECALLER_ID_UPDATION_SECTION.clientDetailsByRefNumber,
    payload,
  );
  return response.data;
};

export const getUserIDs = async () => {
  const response = await api.get(TELECALLER_ID_UPDATION_SECTION.userIDs);
  return response.data;
};

export const updateTelecallerUserID = async (payload) => {
  const response = await api.post(
    TELECALLER_ID_UPDATION_SECTION.telecallerIDUpdate,
    payload,
  );
  return response.data;
};

export const unmapTelecallerID = async (payload) => {
  const response = await api.post(
    TELECALLER_ID_UPDATION_SECTION.telecallerIDUnmap,
    payload,
  );
  return response.data;
};
